import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useClient } from 'src/contexts';
import {
  CustomerGroupApiType,
  CustomerGroupsReponseApiType,
} from 'src/features/Customers/Details/Groups/types';

interface CustomerParentGroupsSelectProps {
  id: string;
  name: string;
  customerId: string;
  placeholder: string;
  defaultValue?: string;
  onChange?: (parent: string) => void;
}

export const CustomerParentGroupsSelect: React.FC<
  CustomerParentGroupsSelectProps
> = ({ id, name, customerId, placeholder, defaultValue, onChange }) => {
  const { get } = useClient();
  const [parentGroups, setParentGroups] = useState<CustomerGroupApiType[]>([]);

  useEffect(
    () =>
      get(
        `/customers/${customerId}/groups?per_page=2000`,
        (response: CustomerGroupsReponseApiType) =>
          response.data && setParentGroups(response.data)
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customerId]
  );

  return (
    <Select
      id={id}
      placeholder={placeholder}
      size="large"
      data-testid={name}
      defaultValue={defaultValue}
      onChange={onChange}
    >
      <Select.Option key="detach" value="detach">
        <>aucun parent (Réseau)</>
      </Select.Option>
      {/* Réseaux and their communities: a sub-community cannot be a parent (3 levels max) */}
      {parentGroups &&
        parentGroups.flatMap((network: CustomerGroupApiType) => [
          <Select.Option key={network.id} value={network.id}>
            {network.name}
          </Select.Option>,
          ...(network.children ?? []).map((community: CustomerGroupApiType) => (
            <Select.Option key={community.id} value={community.id}>
              {`— ${community.name}`}
            </Select.Option>
          )),
        ])}
    </Select>
  );
};
